// https://vuex.vuejs.org/en/state.html

export default {
  authStatus: '',
  token: localStorage.getItem('token') || '',
  refreshToken: localStorage.getItem('refresh_token') || '',
  tokenExpiration: new Date(localStorage.getItem('token_expiration')) || '',
  
  permissions: [],
  currentUser: {},
  loading: false,
}
